import { Component, Inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormControl } from '@angular/forms';
import { TagOption } from '@vendasta/forms';
import { SnackbarService } from '@vendasta/galaxy/snackbar-service';
import { Opportunity } from '@vendasta/sales-opportunities';
import { Observable, combineLatest, debounceTime, firstValueFrom, map } from 'rxjs';
import { OpportunityService } from '../../../../../../opportunity.service';
import { SALES_UI_OPPORTUNITY_DETAILS_CONFIG_TOKEN, SalesUIOpportunityDetailsConfig } from '../../../../../../tokens';

@Component({
  selector: 'sales-ui-subscribers-selector',
  templateUrl: './subscribers-selector.component.html',
})
export class SubscribersSelectorComponent {
  readonly opportunity$: Observable<Opportunity>;
  protected salespeople$: Observable<TagOption[]>;
  protected subscribersFormControl = new FormControl<string[]>({
    value: [],
    disabled: true,
  });

  constructor(
    @Inject(SALES_UI_OPPORTUNITY_DETAILS_CONFIG_TOKEN) private readonly config: SalesUIOpportunityDetailsConfig,
    private readonly opportunityUpdatesService: OpportunityService,
    private snackbarService: SnackbarService,
  ) {
    this.opportunity$ = this.opportunityUpdatesService.currentOpportunity$;
    this.opportunity$.pipe(takeUntilDestroyed()).subscribe((opportunity) => {
      this.subscribersFormControl.setValue(opportunity.subscriberUserIds, { emitEvent: false });
      this.subscribersFormControl.enable({ emitEvent: false });
    });

    this.salespeople$ = combineLatest([this.opportunity$, this.config.salespeople$]).pipe(
      takeUntilDestroyed(),
      map(([opportunity, salespeople]) =>
        salespeople
          .filter((sp) => sp.id !== opportunity.salesPersonId)
          .map((sp) => <TagOption>{ name: sp.fullName, value: sp.id }),
      ),
    );

    this.subscribersFormControl.valueChanges
      .pipe(takeUntilDestroyed(), debounceTime(500))
      .subscribe((salesUserIds: string[]) => {
        firstValueFrom(this.opportunityUpdatesService.updateSubscribers(salesUserIds))
          .then(() =>
            this.snackbarService.openSuccessSnack('FRONTEND.SALES_UI.SALES_OPPORTUNITIES.SUBSCRIBERS_UPDATED'),
          )
          .catch(() =>
            this.snackbarService.openErrorSnack('FRONTEND.SALES_UI.SALES_OPPORTUNITIES.SUBSCRIBERS_UPDATE_ERROR'),
          );
      });
  }
}
